import { Suggestions } from "../suggestions.entity";
import { Departments } from "apps/services/masters/src/app/departments/departments.entity";
import { SuggestionsDTO } from "./suggestions.dto";

export class SuggestionsAdapter{

    convertDtoToEntity(dtoObj: SuggestionsDTO, isUpdate: boolean = false): Suggestions{
        try{
            const entityObj = new Suggestions();
            entityObj.suggestionId = dtoObj.suggestionId;
            entityObj.suggestion = dtoObj.suggestion;
            entityObj.suggestionType = dtoObj.suggestionType;
            entityObj.departmentId= dtoObj.departmentId;
            entityObj.departmentName = dtoObj.departmentName;
            entityObj.remarks = dtoObj.remarks;
            entityObj.status = dtoObj.status;            
            entityObj.employeeId = dtoObj.employeeId;
            entityObj.employeeName = dtoObj.employeeName;
            if(isUpdate){
                entityObj.updatedUser = dtoObj.updatedUser;
            }else {
                entityObj.isActive = true;
                entityObj.createdUser = dtoObj.createdUser;
            }
            return entityObj;
        }catch(error){
            throw error;
        }
    }

    public convertEntityToDto(entityObj: Suggestions): SuggestionsDTO{
        const dtoObj = new SuggestionsDTO();
        dtoObj.suggestionId = entityObj.suggestionId;
        dtoObj.suggestion = entityObj.suggestion;
        dtoObj.suggestionType = entityObj.suggestionType;
        dtoObj.departmentId = entityObj.departmentId;
        dtoObj.departmentName = entityObj.departmentName;
        dtoObj.remarks = entityObj.remarks;
        dtoObj.status = entityObj.status;
        dtoObj.isActive = entityObj.isActive;
        dtoObj.createdAt = entityObj.createdAt;
        dtoObj.createdUser = entityObj.createdUser;
        dtoObj.updatedAt = entityObj.updatedAt;
        dtoObj.updatedUser = entityObj.updatedUser;
        dtoObj.versionFlag = entityObj.versionFlag;
        dtoObj.employeeId = entityObj.employeeId;
        dtoObj.employeeName = entityObj.employeeName;
        return dtoObj;
    }
}